<div class="chart-container" style="height: 100%;">
  <canvas #chartCanvas  [id]="'cf-bar-chart-' + unique_id" height="100%"></canvas>
</div>
